import React from 'react'
import { Registry } from '@react-registry'
import { elementCategories } from '../../elementCategories'

import { OrderedListIcon } from '../../../utils/Icon'
//@ts-ignore
import styles from '../style.module.css'
import { useSlate } from 'slate-react'
import { isListActive, setListTypeAttrs, toggleList } from '../utils'

const format = 'ol'

export const OrderedList = (props) => {
  const extraAttrs = setListTypeAttrs(props);
  return (
    <div {...props.attributes} {...props.attrs} className={styles['list']}>
      <ol {...extraAttrs} >{props.children}</ol>
    </div>
  )
}

export const OrderedListToggleButton = (props) => {
  const editor = useSlate()

  const handleMouseDown = (event) => {
    toggleList(event, editor, format)
  }

  return <React.Fragment>{props.children({ handleMouseDown, active: isListActive(editor, format) })}</React.Fragment>
}

export const shortcutOrderedListToggle = (event, editor, format, registryObj) => {
  toggleList(event, editor, format)
}

export * from './deserializer'

Registry.register(
  {
    Component: OrderedList,
    IngressComponent: OrderedListToggleButton,
    iconName: <OrderedListIcon />,
    shortcut: { key: 'mod+shift+7', callback: shortcutOrderedListToggle },
    title: 'Ordered list',
    subtitle: 'Ordered list of Items',
    category: elementCategories.LIST_ITEMS,
    isContentStackElement: true,
    inBasicToolbar: false,
    dndOptions: {
      DisableDND: true
    }
  },
  { id: format, registry: 'element' }
)
